import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { LoggingService } from '../shared/services/logging/logging.service';
import { IUserInfo } from '../user-info/IUserInfo';
import * as fromUser from '../user-info/store/user.reducer';

@Component({
    selector: 'ef-member',
    templateUrl: './member.component.html',
    styleUrls: ['./member.component.scss'],
    standalone: false
})
export class MemberComponent implements OnInit, OnDestroy {
    private userSub: Subscription;
    // @Input() public member: IMember;
    public companyName: string;
    public userInfo$: Observable<IUserInfo>;
    private active = true;
    constructor(
        private store: Store<fromUser.State>,
        private log: LoggingService
    ) {
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
    }

    // ngOnDestroy(): void {
    //   this.userSub.unsubscribe();
    // }

    ngOnInit() {
        this.userInfo$.pipe(takeWhile(() => this.active)).subscribe(info => {
            this.log.verbose({ type: 'MemberComponent:userInfo$', info });
            if (info) {
                this.companyName = info.CompanyName;
            }
        });
        // this.member = {name: 'Sample Research Group'};
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
